module.exports = __webpack_public_path__ + "static/app-preview-aa59681f6556b0ee7a11380d30087117.mp4";